<template>
    <b-row>
        <b-col cols="12" v-if="!plazosSeleccionados">
            <h4 v-if="datos_compradores.length > 0">¿Desea realizar el pago de sus abonos a plazos?</h4>
            <h4 v-else>¿Desea realizar el pago de su abono a plazos?</h4>
            <button
                type="button"
                class="button effect-button"
                @click="show_modal = true"
                :disabled="disabled"
            >
                <span>{{ $t('bases.pago_plazos') }}</span>
            </button>
        </b-col>

        <b-col cols="12" v-else>
            <template v-if="compraConPlazos">
                <div class="col-12 pl-0">
                    <h4>Resumen de los plazos solicitados y el importe que pagará en cada uno:</h4>
                </div>
                <div class="col-12 pl-0">
                    <template v-for="(abono, index) in datos_compradores">
                        <h4 :key="'abono-' + index">Abono {{ ++index }}</h4>
                        <ul :key="index">
                            <template v-for="(plazo, key) in abono.plazos_pendientes">
                                <li :key="key">
                                    <template v-if="plazo.gastos_internos == 0">
                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe + plazo.gastos  | formatear_precio }} <span v-if="gastos && key > 1">/ (Gastos de gestión: {{ gastos }} €) </span>
                                    </template>
                                    <template v-else>
                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe  | formatear_precio }}
                                    </template>
                                </li>
                            </template>                                
                        </ul>
                    </template>
                </div>
            </template>
            <h5>Si desea pagar el importe completo, o modificar los plazos, clique en sus correspondientes botones:</h5>
            <button type="button" class="button effect-button" @click="reset()" :disabled="disabled"><span>{{ $t('bases.importe_completo') }}</span></button>
            <button type="button" class="button effect-button ml-2" @click="show_modal = true" :disabled="disabled"><span>{{ $t('bases.modificar_plazos') }}</span></button>
            <template v-if="error_plazos">
                <b-alert
                    class="mt-3"
                    :show="error_plazos"
                    variant="danger"
                >
                    No es posible fraccionar los plazos de pago con fecha superior a fecha {{ teatro.fecha_limite_plazos }}
                </b-alert>
            </template>
        </b-col>

        <b-modal
            size="lg"
            centered
            :hide-footer="true"
            v-model="show_modal"
            title="Activar el pago en plazos"
        >
            <b-row>
                <b-col cols="12">
                    <p>{{ $t('bases.texto_plazos') }}</p>
                </b-col>
                <b-col cols="12">
                    <ValidationObserver tag="form" ref="observer2" @submit="terminar()">
                        <b-row>
                            <b-col md="6" sm="12">
                                <ValidationProvider name="cuotas" id='cuotas' rules="required" class="mr-2" v-slot="{ errors }">
                                    <multiselect 
                                        v-model="data.plazoSelect"
                                        id='cuotas-input'
                                        placeholder="Selecciona la cantidad de plazos"
                                        :options="cuotas"
                                        :show-labels="false"
                                        :max-height="150"
                                    />
                                    <span v-if="errors[0]" class="error invalid-feedback alert-danger white p-1" style="display: block">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" sm="12">
                                <ValidationProvider v-if="frecuencias && frecuencias.length > 0" name="frecuencia" id='frecuencia' rules="required" v-slot="{ errors }">
                                    <multiselect
                                        v-model="data.frecuenciaSelect"
                                        id='frecuencias-input'
                                        label="frecuencia_formatted"
                                        track-by="id"
                                        placeholder="Selecciona la frecuencia disponible"
                                        :options="frecuencias"
                                        :show-labels="false"
                                        :max-height="150"
                                    />
                                    <span v-if="errors[0]" class="error invalid-feedback alert-danger white p-1" style="display: block">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </b-col>                            
                        </b-row>
                        <b v-if="tiene_gastos"><p class="pt-3">{{ $t('bases.aviso_gd', {gd: gastos}) }}</p></b>
                        <div class="mt-3">
                            <Button class="mr-2" type="button" name="button" @click="terminar()">{{ $t('formularios.continuar') }}</Button>
                            <Button type="button" name="button" @click="show_modal = false">{{ $t('formularios.atras') }}</Button>
                        </div>
                    </ValidationObserver>
                </b-col>
            </b-row>
        </b-modal>
    </b-row>
</template>

<script>

    export default {
        props: {
            frecuencias: {
                type: Array,
                required: true
            },
            min_plazos: {
                type: Number,
                required: true
            },
            max_plazos: {
                type: Number,
                required: true
            },
            gastos: {
                type: Number,
                required: true
            },
            error_plazos: {
                type: Boolean,
                required: false,
                default:false
            },
            tiene_gastos: {
                type: Boolean,
                required: true
            },
            datos_compradores: {
                required: true
            },
            compraConPlazos: {
                type: Boolean,
                required: true
            },
            plazosSeleccionados: {
                type: Boolean,
                required: true
            },
            disabled: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                data: {},
                show_modal: false
            }
        },
        watch: {
            show_modal() {
                this.data = {};
            }
        },
        computed: {
            cuotas() {
                let cuotas = [];

                for (var i = this.min_plazos; i <= this.max_plazos; i++) {
                    cuotas.push(i);
                }

                return cuotas;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            async terminar() {
                const isValid = await this.$refs.observer2.validate();

                if (isValid) {
                    this.$emit('plazosSeleccionados', true);
                    this.show_modal = false;
                    this.$emit("terminado", this.data);
                }
            },
            reset() {
                this.$emit('plazosSeleccionados', false);
                this.$emit('reset');
            }
        }
    }
</script>
